import { Component, Input, inject } from '@angular/core';
import { Params } from '@angular/router';
import { RoutingService } from '../../service/common/routing/routing.service';
import { ErzeugungsanlageFilter } from '../../service/erzeugungsanlage/erzeugungsanlage-filter';

@Component({
    selector: 'tnb-dashboard-netzzuordnungen',
    templateUrl: './dashboard-netzzuordnungen.component.html',
    styleUrls: [
        './dashboard-netzzuordnungen.component.scss',
    ],
    standalone: false,
})
export class DashboardNetzzuordnungenComponent {
    private routingService = inject(RoutingService);

    @Input() invalidNetzzuordnungen?: number = null;

    public get routerLink(): string | null {
        return this.routingService.erzeugungsanlagePath();
    }

    public get queryParams(): Params {
        return { status: false } as ErzeugungsanlageFilter;
    }

}
